<template>
  <transition name="fade">
    <v-alert
      class="floating-alert"
      :value="alert.show"
      :type="alert.type"
      :border="alert.border"
      :dismissible="alert.dismissible"
      @input="onDismiss"
    >
      <div v-if="alert.title" class="text-h6 mb-2">
        {{ alert.title }}
      </div>

      <div class="alert-text" v-html="alert.text"></div>
    </v-alert>
  </transition>
</template>

<script lang="ts">

// libs
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'AlertFloating',

  data() {
    return {
      timeoutId: null as any,
    };
  },

  computed: {
    ...mapGetters([
      'alert',
    ]),
  },

  watch: {
    'alert.show': function handleAlertShow(show: boolean) {
      if (show && this.alert.timeout && this.alert.timeout > 0) {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
          this.close();
        }, this.alert.timeout);
      } else if (!show && this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
  },

  methods: {
    ...mapActions([
      'updateAlert',
    ]),
    close() {
      this.updateAlert({ ...this.alert, show: false });
    },
    onDismiss(value: boolean) {
      if (!value) {
        this.close();
      }
    },
  },
});

</script>

<style scoped lang="scss">

.floating-alert {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);   /* centers horizontally */
  width: 90%;
  max-width: 700px;
  z-index: 9999;
}

.floating-alert::v-deep .v-alert__dismissible {
  align-self: flex-start;
  margin-top: 0;
}

.alert-text {
  white-space: pre-line;
  line-height: 1.6;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
